// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.graph-container[data-v-10bcd8a9] {\n  height: 300px;\n}\n", ""]);
// Exports
module.exports = exports;
